<div class="env-marker" [ngClass]="envName"></div>

<ejs-appbar class="app-bar">
  @if(authService.isAuthenticated$ | async){
  <ng-container>
    <div class="d-flex menu-content">
      <img class='logo-img' src="../assets/img/Ocado_MasterBrand_Horizontal_Grape_RGB_141220.png" (click)="home()"
        alt="Logo" />
      <div class="action-items">
        <span class="e-icons icon-notification-bell notification-icon" (click)="notificationTab()">
          @if (notificationCount > 0) {
          <span
            class="e-badge e-badge-warning e-badge-notification e-badge-overlap e-badge-circle">{{notificationCount}}</span>
          }
        </span>
        <span class="pipe">|</span>
        <div class="d-flex user-account spacing">
          <img class='avatar' [src]="user?.picture" alt="Avatar" />
          <div class="user-name">
            @if((user?.name?.length || 0) > 20){
            <ejs-tooltip [content]="user?.name">
              <div class="name">{{ user?.name || '' | longText:20 }}</div>
            </ejs-tooltip>
            } @else {
            <div class="name">{{user?.name}}</div>
            }
            @if((authData.company_name.length || 0) > 20){
            <ejs-tooltip [content]="authData.company_name">
              <div class="company">{{ authData.company_name || '' | longText:20 }}</div>
            </ejs-tooltip>
            } @else {
            <div class="company">{{authData.company_name}}</div>
            }
            <!-- <span class="row company">{{ authData.company_name }}</span> -->
          </div>
        </div>
        <span class="pipe">|</span>
        <span class="log-out spacing" (click)="logout()" i18n>Logout</span>
        <span id="content" class="e-icons icon-grid-solid waffle-button" [ngClass]="waffleTooltip?'waffle-active':''"
          (click)="waffleOpen($event)"></span>

      </div>
    </div>
  </ng-container>
  } @else {
  <ng-template #loggedOut>
  </ng-template>
  }
</ejs-appbar>
@if (buildDialog) {
<ejs-dialog cssClass="build-dialog" #dialog>
  <ng-template #content>
    @for (activeApplication of activeApplicationList.BUILD_VERSIONS; track $index) {
    <div class="application-section">{{activeApplication.application}} :
      {{activeApplication.major}}.{{activeApplication.minor}}</div>
    }
  </ng-template>
</ejs-dialog>
}
@if(waffleTooltip){
<ejs-dialog #tooltip cssClass="tooltip-dialogbox">
  <ng-template #content>
    <div class="demo-content">
      <div class="explore-section">
        <div class="explore-text" i18n>Explore!</div>
        <span class="inner-content" i18n>You can now explore other platforms</span>
      </div>
      <div class="row content-section">
        @for (activeApplication of activeApplicationList.WAFFLE; track $index) {
        <div class="col-3 application-section">
          <a href="{{activeApplication[envName]}}" target="_blank">
            <div class="link-icon">
              <span [className]="'e-icons '+activeApplication.icon" [style]="{color:activeApplication.colour}"></span>
            </div>
            <div class="applicaion-text">
              {{activeApplication.name}}
            </div>
          </a>
        </div>
        }
      </div>
      <div class="date-section">
        @if (ocadoAuthService.isStaff) {
        <div (click)="buildOpen($event)" id="buildDlg" class="built-version" i18n>Built Version</div>
        }
      </div>
    </div>
  </ng-template>
</ejs-dialog>
}
<router-outlet></router-outlet>